<template>
    <div class="custom-actions">
        <div>
            <button class="ui basic button yellow" @click="deliberateRole(rowData)"><i class="fas fa-thumbs-up"></i> Delibera </button>
            <button class="ui basic button yellow"   @click="approveRole(rowData)"><i class="fas fa-check-circle"></i> Approva </button>
        </div>
    </div>
  </template>

<script>
	export default {
		props: {
            rowData: {
                type: Object,
                required: true
            },
            rowIndex: {
                type: Number,
                required: true
            },
            isVueTable: {
                type: Boolean,
                required:false,
                default : true
            }


		},
        mounted() {

        },
        methods: {

            deliberateRole (rowData) {
                Vue.swal.fire({
                    title: 'Are you sure?',
                    text: "You want deliberate this role?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, deliberate it!'
                }).then((result) => {
                    if (result.value) {
                        //alert(rowData.id);
                        axios.post("/roles-deliberate-validate",{'role_id': rowData.id, 'mode' :'deliberate'}).then(
                            response => {
                                if(response.data === -1){
                                    alert('Super Admin users cannot deliberate');
                                }
                                else {
                                    location.reload();
                                }
                            }
                        );
                    }
                });
            },


            approveRole (rowData) {
                //console.log("REJECT ",rowData);
                Vue.swal.fire({
                    title: 'Are you sure?',
                    text: "You want validate this role?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, validate it!'
                }).then((result) => {
                    if (result.value) {

                        axios.post("/roles-deliberate-validate",{'role_id': rowData.id, 'mode' :'validate'})
                            .then(
                                response => {
                                    if(response.data === -1){
                                        alert('Super Admin users cannot approve');
                                    }
                                    else {
                                        location.reload();
                                    }
                                }
                            )
                    }
/*
                        Vue.swal.fire({
                            title: result.message,
                            text: "",
                            icon: 'error',
                        })
*/
                });
            }
        }
	}
</script>

<style>
.custom-actions button.ui.button {
  padding: 8px 8px;
}
.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}
</style>
